module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-main",
    style: (_vm.backgroundStyle)
  }, [(_vm.hasSettingBackground) ? _c('img', {
    staticClass: "setting-image",
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasSettingBackground) ? _c('img', {
    staticClass: "setting-image",
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0360736"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/new-result.vue
// module id = 295
// module chunks = 1